import axios, { AxiosResponse } from 'axios';
import BaseService from './baseService';

interface CadastroDados {
  [key: string]: any;
}

interface CadastroResponse {
  access?: string;
  refresh?: string;
  [key: string]: any;
}

interface TokenData {
  access_token: string;
  refresh_token: string;
}

class CadastroService extends BaseService {
  async cadastrar(dados: CadastroDados): Promise<CadastroResponse> {
    try {
      const response: AxiosResponse<CadastroResponse> = await axios.post(
        `${this.getApiUrl()}/auth/signup`, 
        dados
      );
      
      // Salvar tokens no localStorage se o cadastro for bem-sucedido
      if (response.data.access && response.data.refresh) {
        const acesso: TokenData = {
          access_token: response.data.access,
          refresh_token: response.data.refresh
        };
        localStorage.setItem('bn', btoa(JSON.stringify(acesso)));
      }
      
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new CadastroService(); 